import { navLinks } from "@/mocks/guaData";

export default function Footer() {
  const go = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="border-t border-background-200 bg-accent-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="inline-flex items-center gap-2.5" aria-label="每日有瓜首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-chat-smile-3-line" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">每日有瓜</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              吃瓜群众的聚集地。讨论区、评论区、吃瓜现场实时更新，点开就能看到大家怎么看、热议什么。加入吃瓜现场，一起轻松围观。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-youtube-line", "ri-github-line"].map((ic, i) => (
                <a
                  key={i}
                  href="#top"
                  onClick={(e) => {
                    e.preventDefault();
                    go("top");
                  }}
                  aria-label="社交平台入口"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${ic} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="text-sm font-semibold text-foreground-900">快速导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm text-foreground-600">
              {navLinks.map((l) => (
                <li key={l.key}>
                  <button onClick={() => go(l.key)} className="whitespace-nowrap transition hover:text-primary-600">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">联系与合作</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2"><i className="ri-mail-send-line text-primary-500"></i>hello@meiriyougua.com</li>
              <li className="flex items-center gap-2"><i className="ri-time-line text-primary-500"></i>内容实时更新 · 7×24</li>
            </ul>
            <a
              href="#subscribe"
              onClick={(e) => {
                e.preventDefault();
                go("subscribe");
              }}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              订阅每日瓜报
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 每日有瓜 MeiRiYouGua · 吃瓜群众聚集地</p>
          <p>理性吃瓜 · 友善讨论 · 不造谣不传谣</p>
        </div>
      </div>
    </footer>
  );
}